import React, { useState } from "react";
import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";

import Image1 from "../assets/images/g1.jpg";
import Image2 from "../assets/images/g2.jpg";
import Image3 from "../assets/images/g3.jpg";
import Image4 from "../assets/images/g4.jpg";
import Image5 from "../assets/images/g5.jpg";
import Image6 from "../assets/images/g6.jpg";
import Image7 from "../assets/images/g7.jpg";
import Image8 from "../assets/images/g8.jpg";
import Image9 from "../assets/images/g9.jpg";
import Image10 from "../assets/images/g10.jpg";
import Image11 from "../assets/images/g11.jpg";
import Image12 from "../assets/images/g12.jpg";
import Image13 from "../assets/images/g13.jpg";
import Image14 from "../assets/images/g14.jpg";
import Image15 from "../assets/images/g15.jpg";
import Image16 from "../assets/images/g16.jpg";
import Image17 from "../assets/images/g17.jpg";
import Image18 from "../assets/images/g18.jpg";
import Image19 from "../assets/images/g19.jpg";
import Image20 from "../assets/images/g20.jpg";
import Image21 from "../assets/images/g21.jpg";
import Image22 from "../assets/images/g22.jpg";
import Image23 from "../assets/images/g23.jpg";
import Image24 from "../assets/images/g24.jpg";
import Image25 from "../assets/images/g25.jpg";
import Image26 from "../assets/images/g26.jpg";
import Image27 from "../assets/images/g27.jpg";
import Image28 from "../assets/images/g28.jpg";
import Cta from "./Cta";

const images = [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
  Image9,
  Image10,
  Image11,
  Image12,
  Image13,
  Image14,
  Image15,
  Image16,
  Image17,
  Image18,
  Image19,
  Image20,
  Image21,
  Image22,
  Image23,
  Image24,
  Image25,
  Image26,
  Image27,
  Image28,
];


const projectList = [
  { image: Image1 },
  { image: Image2 },
  { image: Image3 },
  { image: Image4 },
  { image: Image5 },
  { image: Image6 },
  { image: Image7 },
  { image: Image8 },
  { image: Image9 },
  { image: Image10 },
  { image: Image11 },
  { image: Image12 },
  { image: Image13 },
  { image: Image14 },
  { image: Image15 },
  { image: Image16 },
  { image: Image17 },
  { image: Image18 },
  { image: Image19 },
  { image: Image20 },
  { image: Image21 },
  { image: Image22 },
  { image: Image23 },
  { image: Image24 },
  { image: Image25 },
  { image: Image26 },
  { image: Image27 },
  { image: Image28 },
];
export default function Portfolio1() {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [visibleCount, setVisibleCount] = useState(12);

  const handleImageClick = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  const handleLoadMore = () => {
    if (visibleCount === 12) {
      setVisibleCount(20);
    } else {
      setVisibleCount(projectList.length);
    }
  };

  return (
    <>
      <section
        className="relative min-h-[600px] py-16 md:py-24 bg-gray-50 dark:bg-slate-800"
        id="portfolio"
      >
        <div className="container">
          <div className="grid grid-cols-1 pb-8 text-center">
            <h6 className="text-[#69A41D] text-[40px] font-medium uppercase mb-2 mt-24">
              Portfolio
            </h6>

            <p className="text-slate-400 dark:text-slate-300 max-w-xl mx-auto mt-3 mb-5 text-[18px]">
              Explore the High-Quality Packaging Projects we have Delivered.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
            {projectList.slice(0, visibleCount).map((item, index) => (
              <div
                className="relative rounded-md shadow-sm overflow-hidden group cursor-pointer"
                key={index}
                onClick={() => handleImageClick(index)}
              >
                <img
                  src={item.image}
                  className="w-full h-[300px] object-cover group-hover:scale-110 group-hover:rotate-3 transition duration-500"
                  alt={item.title}
                />

                <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-40 transition duration-500"></div>

                <div className="absolute bottom-4 left-4 z-10 opacity-0 group-hover:opacity-100 transition duration-500">
                  <h5 className="text-white font-semibold">{item.title}</h5>
                  <p className="text-slate-200 text-sm">{item.subtext}</p>
                </div>
              </div>
            ))}
          </div>

          {visibleCount < projectList.length && (
            <div className="text-center mt-10">
              <button
                onClick={handleLoadMore}
                className="px-6 py-3 bg-[#69A41D] hover:bg-[#5a8c18] text-white font-medium rounded-md transition duration-300"
              >
                {visibleCount === 12 ? "Load More" : "Show All"}
              </button>
            </div>
          )}

          {isOpen && (
            <Lightbox
              mainSrc={images[photoIndex]}
              nextSrc={images[(photoIndex + 1) % images.length]}
              prevSrc={images[(photoIndex + images.length - 1) % images.length]}
              onCloseRequest={() => setIsOpen(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + images.length - 1) % images.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % images.length)
              }
            />
          )}
        </div>
      </section>

    </>
  );
}